import { render, staticRenderFns } from "./EditarFuncionesGlobales.vue?vue&type=template&id=a14ef12e&"
import script from "./EditarFuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./EditarFuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports